import { ApplicationConfig, provideBrowserGlobalErrorListeners, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from './core/interceptors/api-interceptor';
import { errorInterceptor } from './core/interceptors/error-interceptor';
import { offlineSearchInterceptor } from './core/interceptors/offline-search-interceptor';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
// Global Error listener provider from your original configuration
    provideBrowserGlobalErrorListeners(),

    // Core routing provider configuration
    provideRouter(routes),

    // HTTP Client provider registering both modern functional authentication interceptors
    provideHttpClient(
      withInterceptors([apiInterceptor, offlineSearchInterceptor, errorInterceptor])
    ),

    // PWA Service worker runtime management registration
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
